import { Group, Progress } from '@mantine/core'
import {
  HostOnboardingSteps,
  OnboardingWizardPages,
} from '../../utils/constants'

interface ProgressBarProps {
  currentStep: number
  pageName: OnboardingWizardPages
}
export const ProgressBar = (props: ProgressBarProps) => {
  const { currentStep, pageName } = props
  return (
    <Group
      w={'100%'}
      pl={{ base: 20, sm: 60 }}
      pr={{ base: 20, sm: 60 }}
      align='center'
    >
      {(pageName === OnboardingWizardPages.Onboarding ||
        pageName === OnboardingWizardPages.ManageLocation) && (
        <Progress value={(currentStep / 6) * 100} flex={1} />
      )}
      {pageName === OnboardingWizardPages.Onboarding && (
        <Progress
          value={
            currentStep === HostOnboardingSteps.BankingInfo
              ? 50
              : currentStep > HostOnboardingSteps.BankingInfo
              ? 100
              : 0
          }
          flex={1}
        />
      )}
      {(pageName === OnboardingWizardPages.Onboarding ||
        pageName === OnboardingWizardPages.ManageDevice) && (
        <Progress
          value={
            currentStep >= HostOnboardingSteps.DeviceSetupInstructions
              ? ((currentStep - HostOnboardingSteps.DeviceSetupInstructions) /
                  9) *
                100
              : 0
          }
          flex={1}
        />
      )}
    </Group>
  )
}
